import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    AdGroup,
    Campaign,
    Keyword,
    Portfolio,
    ProductAd,
} from "@ts/common-types";
const portfoliosAggregationSlice = createSlice({
    name: "portfoliosAggregatedData",
    initialState: { value: {} },
    reducers: {
        updatePortfoliosAggregatedData: (
            state,
            action: PayloadAction<Portfolio>
        ) => {
            state.value = action.payload;
        },
    },
});

const campaignsAggregationSlice = createSlice({
    name: "campaignsAggregatedData",
    initialState: { value: {} },
    reducers: {
        updateCampaignsAggregatedData: (
            state,
            action: PayloadAction<Campaign>
        ) => {
            state.value = action.payload;
        },
    },
});

const adgroupsAggregationSlice = createSlice({
    name: "adgroupsAggregatedData",
    initialState: { value: {} },
    reducers: {
        updateAdgroupsAggregatedData: (
            state,
            action: PayloadAction<AdGroup>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordsAggregationSlice = createSlice({
    name: "keywordsAggregatedData",
    initialState: { value: {} },
    reducers: {
        updateKeywordsAggregatedData: (
            state,
            action: PayloadAction<Keyword>
        ) => {
            state.value = action.payload;
        },
    },
});

const productsAggregationSlice = createSlice({
    name: "productsAggregatedData",
    initialState: { value: {} },
    reducers: {
        updateProductsAggregatedData: (
            state,
            action: PayloadAction<ProductAd>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { updatePortfoliosAggregatedData } =
    portfoliosAggregationSlice.actions;
export const { updateCampaignsAggregatedData } =
    campaignsAggregationSlice.actions;
export const { updateAdgroupsAggregatedData } =
    adgroupsAggregationSlice.actions;
export const { updateKeywordsAggregatedData } =
    keywordsAggregationSlice.actions;
export const { updateProductsAggregatedData } =
    productsAggregationSlice.actions;

export const portfoliosAggregatedDataReducer =
    portfoliosAggregationSlice.reducer;
export const campaignsAggregatedDataReducer = campaignsAggregationSlice.reducer;
export const adgroupsAggregatedDataReducer = adgroupsAggregationSlice.reducer;
export const keywordsAggregatedDataReducer = keywordsAggregationSlice.reducer;
export const productsAggregatedDataReducer = productsAggregationSlice.reducer;
